<template>
  <el-tabs>
    <el-tab-pane label="Solicitud del Ciudadano">
      <div class="row pt-4">
        <div class="col">
          <p class="title">Con fecha de {{ model.afiliacionFecha }} a las {{ model.afiliacionFechaHora }},
            se realizó la solicitud
            de afiliación, con la siguiente información:</p>
        </div>
      </div>

      <afiliacion-detail
        :telefono-fijo="model.telefonoFijo"
        :telefono-movil="model.telefonoMovil"
        :email="model.email"
        :fecha-nacimiento="model.fechaNacimiento"
        :domicilio="model.domicilio"
        :nombre-completo="model.nombreCompleto"
        :rut="model.rut">
      </afiliacion-detail>
    </el-tab-pane>

    <el-tab-pane label="Revisión de Solicitud">
      <revision-solicitud-ver
        class="pt-4"
        v-if="!loading"
        :revision-fecha="model.revision.revisionFecha"
        :revision-fecha-hora="model.revision.revisionFechaHora"
        :estado-revision-codigo="model.revision.estadoRevisionCodigo"
        :estado-revision="model.revision.estadoRevision"
        :motivo-rechazo-codigo="model.revision.motivoRechazoCodigo"
        :motivo-rechazo="model.revision.motivoRechazo"
        :lista-rechazo="model.revision.listaRechazo"
        :descripcion-rechazo="model.revision.descripcionRechazo"
        :instancia="model.revision.instancia"
        :fecha-maxima="model.revision.fechaMaxima">

      </revision-solicitud-ver>
    </el-tab-pane>

    <el-tab-pane label="Revisión de Solicitud con Reclamación" v-if="model.revision.estadoRevisionCodigo === 2">
      <revision-solicitud-reclamacion-ver
        class="pt-4"
        v-if="!loading"
        :reclamacion-fecha="model.reclamacion.reclamacionFecha"
        :reclamacion-fecha-hora="model.reclamacion.reclamacionFechaHora"
        :presenta-reclamacion="model.reclamacion.presentaReclamacion"
        :estado-reclamacion="model.reclamacion.estadoReclamacion"
        :estado-reclamacion-codigo="model.reclamacion.estadoReclamacionCodigo"
        :lista-estado-reclamacion="model.reclamacion.listaEstadoReclamacion"
        :motivos-rechazo="model.reclamacion.motivosRechazo"
        :document="model.reclamacion.document">
      </revision-solicitud-reclamacion-ver>
    </el-tab-pane>

    <el-tab-pane label="Documentos">
      <div class="row pt-4">
        <div class="col-md-12">
          <template v-if="model.documentoFicha !== null || model.archivomanual !== null">
            <p class="title">Ficha de afiliación a partido político.</p>
            <el-link type="warning" @click="downloadDocument">Descargar Ficha Adjunto.
              <em class="el-icon-download el-icon--right"></em>
            </el-link>
          </template>
          <template v-else>

            <p>
              <em class="pp-icon-32 pp-color-danger el-icon-info"></em>
              No hay documentos asociados a esta afiliación a partido político.
            </p>
          </template>

        </div>
      </div>
    </el-tab-pane>

    <el-tab-pane label="Estado">
      <div class="row pt-4">
        <template v-if="media.sm">
          <div class="col-md-12">
            <el-descriptions :column="1" border direction="vertical">
              <el-descriptions-item content-class-name="pp-el-descriptions-item">
                <template slot="label">
                  <span class="el-icon-bell"></span>
                  Estado de la afiliación:
                </template>
                <el-tag class="mt-1" :type="estadoTag(model.codigoestado)">{{ model.estado }}</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </template>
        <template v-else>
          <div class="col-md-4">
            <el-descriptions :column="1" border>
              <el-descriptions-item content-class-name="pp-el-descriptions-item">
                <template slot="label">
                  <span class="el-icon-bell"></span>
                  Estado de la afiliación:
                </template>
                <el-tag class="mt-1" :type="estadoTag(model.codigoestado)">{{ model.estado }}</el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </template>
      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
import {Descriptions, DescriptionsItem, Link, TabPane, Tabs, Tag} from "element-ui";
import AfiliacionDetail from "@/components/Shared/AfiliacionDetail/AfiliacionDetail";
import RevisionSolicitudVer
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/RevisionSolicitudVer/RevisionSolicitudVer";
import RevisionSolicitudReclamacionVer
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/RevisionSolicitudReclamacionVer/RevisionSolicitudReclamacionVer";
import moment from "moment-timezone";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";

export default {
  name: "RevisionLayoutTab",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Link.name]: Link,
    [Tag.name]: Tag,
    AfiliacionDetail,
    RevisionSolicitudVer,
    RevisionSolicitudReclamacionVer,
  },
  props: {
    model: Object,
    loading: Boolean
  },
  mixins: [
    ScreenSizeMixin,
    ActividadCiudadanoEstadoMixin
  ],
  methods: {
    downloadDocument() {
      let data = this.model.manual ? this.model.archivomanual : this.model.documentoFicha
      let link = document.createElement('a')
      // Eliminamos las primeras y últimas comillas
      data = data.slice(1, -1);
      // Eliminamos las comillas dobles internas (si las hay)
      data = data.replace(/"/g, '');
      link.href = data
      const date = moment().format('YYYYMMDDhhmmss')
      link.download = `documento-ficha-${date}.pdf`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
}
</script>
